import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get consistent user initials from a name string.
 * Returns first letter of first word + first letter of last word.
 * Examples: "Sam King" -> "SK", "Sam Alexander King" -> "SK", "Sam" -> "S"
 */
export function getInitials(name?: string | null): string {
  if (!name || name.trim() === "") return "U";
  const words = name.trim().split(/\s+/).filter(w => w.length > 0);
  if (words.length >= 2) {
    // First letter of first word + first letter of last word
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  // Single word: just return first letter
  return words[0][0].toUpperCase();
}
